import { gql } from '@apollo/client';

export const READ_CORPORATE_ACCOUNT_DISCOUNT = gql`
  query Query($input: ReadCorporateAccountDiscountInput!) {
    readCorporateAccountDiscount(input: $input) {
      discountPercent
      transactionFee
      evEnergyDiscountPercent
    }
  }
`;
